"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
/**
 * ### Production-ready Checklist:
 * * (✔) implementation of component approved by design team;
 * * (✔) has storybook, covered with stories and documentation;
 * * (✔) has tests: test every prop, every state and every interaction that's js related;
 * * (see apps/test/unit/componentLibrary/FontAwesomeV6IconTest.jsx)
 * * (?) passes accessibility checks;
 *
 * ###  Status: ```Ready for dev```
 *
 * Design System: FontAwesomeV6Icon Component.
 * Simple shortcut for FontAwesomeV6 icons. Requires FontAwesomeV6 to be installed.
 * Not a part of Design System in Figma initially, but is used in some of Design System components.
 * Can can be used in any component in/out of the scope of Design System.
 */
var FontAwesomeV6Icon = function (_a) {
    var iconStyle = _a.iconStyle, iconName = _a.iconName, className = _a.className, title = _a.title;
    return (react_1.default.createElement("i", { "data-testid": "font-awesome-v6-icon", className: (0, classnames_1.default)(iconStyle && "fa-".concat(iconStyle), iconName && "fa-".concat(iconName), className), title: title }));
};
exports.default = FontAwesomeV6Icon;
